import { render, staticRenderFns } from "./UserNotificationForm.vue?vue&type=template&id=7ed05a93&scoped=true&"
import script from "./UserNotificationForm.vue?vue&type=script&lang=js&"
export * from "./UserNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationForm.vue?vue&type=style&index=0&id=7ed05a93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed05a93",
  null
  
)

export default component.exports